
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NewTooltip from '../../../atoms/NewTooltip';
import { ErrorField } from "../../../../types/ErrorField";
import { IoTrashBin } from "react-icons/io5";
import SelectTextField from "../../../molecules/SelectTextField";
import { getErrorMessage } from "../../../../utils/formErrorUtils";
import { useEffect } from "react";
import { toast } from "react-toastify";




interface Props {
    form: any;
    subscriptionTypes: any;
    profilesSubscription: any;
    errorFields: ErrorField[];
    changeForm: (field: string, value: string) => void;
    editForm?: boolean;
}

type DataRow = {
    idx: number;
    profile: string;
    label: string;
    signAs: string;
    useDigitalCertificate: boolean;
    canDelete: boolean;
}



const IndividualFormSubscription: React.FC<Props> = ({ form, subscriptionTypes, profilesSubscription, errorFields, changeForm, editForm = false }) => {
    const [rows, setRows] = useState<DataRow[]>([]);
    const [selectedItem, setSelectedItem] = useState<string>("");

    useEffect(() => {
        setRows([...form.selectedSubscriptionType]);
    }, [form.selectedSubscriptionType]);



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newChecked = e.target.checked;
        rows[index].useDigitalCertificate = newChecked;
        setRows([...rows]);
        form.selectedSubscriptionType = [...rows];
    };

    const addProfile = () => {
        if (!selectedItem) {
            toast.error("Selecione um perfil.");
            return;
        }
        let tmpSelectedItem = subscriptionTypes[selectedItem];
        let found = rows.find((r) => r.profile === tmpSelectedItem.profile && r.signAs === tmpSelectedItem.sign_as);
        if (found) {
            toast.error("Perfil já adicionado.");
            return;
        }
        let row = {
            profile: tmpSelectedItem.profile,
            label: tmpSelectedItem.labelProfile,
            useDigitalCertificate: tmpSelectedItem.useDigitalCertificate || false,
            idx: tmpSelectedItem.value,
            canDelete: true,
            signAs: tmpSelectedItem.sign_as || ''
        }
        setRows([...rows, row]);
        form.selectedSubscriptionType = [...rows, row];
        setSelectedItem("");
    }

    const removeProfile = (label: string, signAs: string) => {
        if (rows.length <= 1) {
            toast.error("É necessário ter pelo menos um perfil.");
            return;
        }
        let updatedRows = rows.filter((row) => row.signAs !== signAs);
        setRows([...updatedRows]);
        toast.success("Perfil removido com sucesso.");
        form.selectedSubscriptionType = [...updatedRows];
    }

    return (
        <div className="p-4 m-4">
            <div className="grid grid-cols-12 gap-8">
                <SelectTextField
                    id="profile"
                    name='profileId'
                    label=""
                    value={selectedItem}
                    items={subscriptionTypes}
                    className="col-span-6"
                    onChange={(e) => {
                        setSelectedItem(e.target.value);
                    }
                    }
                    errorMessage={getErrorMessage(errorFields, "nationalityId")}
                />

                <button
                    id="btn-include-subscription"
                    className="bg-cyan-500 text-white px-4 py-2 rounded hover:bg-cyan-800 disabled:bg-gray-300 disabled:text-gray-500 col-span-2"
                    onClick={addProfile}
                    title="+Incluir"
                >
                    Incluir
                </button>
            </div>

            <div className="grid grid-cols-12 gap-8 mt-4">
                <table className="w-full table-fixed border border-gray-300 divide-y divide-gray-200 col-span-8">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase border w-5/10">Perfil</th>
                            <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase border w-5/10">Assinar como</th>
                            <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase border w-3/10">Usa certificado digital</th>
                            <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase border w-2/10"></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {rows.map((row, index) => (
                            <tr key={index} className={`group ${index % 2 === 0 ? 'bg-slate-100' : ''} hover:bg-slate-300 hover:shadow-md border-b border border-gray-300`}>
                                <td className="py-2 px-4 text-sm text-gray-700" >{row.label}</td>
                                <td className="py-2 px-4 text-sm text-gray-700" >{row.signAs}</td>
                                <td className="py-2 px-4 text-sm text-gray-700 flex items-center justify-center">
                                    <input
                                        id={`checkbox-digital-cert-${index}`}
                                        type="checkbox"
                                        className='w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2 px-2 py-2'
                                        checked={row.useDigitalCertificate}
                                        onChange={(e) => handleChange(e, index)}
                                        title="Usa certificado digital"
                                    />

                                </td>
                                <td>
                                    <div className="flex items-center justify-center opacity-0 group-hover:opacity-100 flex items-center transition-opacity duration-200">
                                        {(row.canDelete) && (
                                            <NewTooltip content="Remover">
                                                <Link
                                                    id={`link-remove-profile-${row.label}`}
                                                    to='/person/partners/form'
                                                    className='text-white bg-red-500 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm  text-center'
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        removeProfile(row.label, row.signAs);
                                                    }
                                                    }
                                                >
                                                    <IoTrashBin className='ml-2 text-2xl text-red-500' />
                                                </Link>
                                            </NewTooltip>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default IndividualFormSubscription;
